import { render, staticRenderFns } from "./IpoAccountTypeReports.vue?vue&type=template&id=55d6f99d&scoped=true"
import script from "./IpoAccountTypeReports.vue?vue&type=script&lang=js"
export * from "./IpoAccountTypeReports.vue?vue&type=script&lang=js"
import style0 from "./IpoAccountTypeReports.vue?vue&type=style&index=0&id=55d6f99d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d6f99d",
  null
  
)

export default component.exports